import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col, Button, Badge, Spinner } from "react-bootstrap";
import {
  FaBell,
  FaCheckDouble,
  FaTrashAlt,
  FaSpinner,
  FaTimes,
} from "react-icons/fa";
import Swal from "sweetalert2";
import "../../../../assets/css/admin/dashboard/Notifications.css";
import AdminLayout from "../../../../layouts/admin/AdminLayout";
import axios from "axios";
import AppContext from "../../../../context/AppContext";

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);

  const [Title, setTitle] = useState("");
  const [Descrption, setDescrption] = useState("");
  const [showAddForm, setShowAddForm] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  const { baseUrl } = useContext(AppContext);

  const unreadCount = notifications.filter((n) => n.status === "unread").length;

  const viewAllNotifications = (loggedInAdmin) => {
    const formData = new FormData();
    formData.append("weadmin_id", loggedInAdmin.id);

    axios
      .post(`${baseUrl}/admin/notifications/viewAllNotifications`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        if (res.data.success === true) {
          setNotifications(res.data.notifications);
          setPageLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setPageLoading(false);
      });
  };

  const createNotification = () => {
    const loggedInAdmin = JSON.parse(localStorage.getItem("adminData"));
    const formData = new FormData();
    formData.append("weadmin_id", loggedInAdmin.id);
    formData.append("title", Title);
    formData.append("descrption", Descrption);
    formData.append("for", "admin");

    axios
      .post(`${baseUrl}/admin/notifications/createNotification`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        if (res.data.success === true) {
          setTitle("");
          setDescrption("");
          setShowAddForm(false);
          viewAllNotifications(loggedInAdmin);
          Swal.fire({
            icon: "success",
            title: "Created!",
            timer: 1500,
            showConfirmButton: false,
          });
        }
      })
      .catch((err) => console.log(err));
  };

  const markAsRead = (id) => {
    const formData = new FormData();
    formData.append("id", id);
    formData.append("status", "read");

    axios
      .post(`${baseUrl}/admin/notifications/updateNotification`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        if (res.data.success === true) {
          setNotifications(
            notifications.map((n) =>
              n.id === id ? { ...n, status: "read" } : n,
            ),
          );
        }
      })
      .catch((err) => console.log(err));
  };

  const markAllAsRead = () => {
    Swal.fire({
      title: "Mark All as Read?",
      text: `${unreadCount} notifications will be marked as read`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#7fd3c1",
      cancelButtonColor: "#f56565",
      confirmButtonText: "Yes, mark all!",
    }).then((result) => {
      if (result.isConfirmed) {
        const loggedInAdmin = JSON.parse(localStorage.getItem("adminData"));
        const formData = new FormData();
        formData.append("weadmin_id", loggedInAdmin.id);
        axios.post(`${baseUrl}/admin/notifications/markAllAsRead`, formData, {headers :{
          'Content-Type' : 'multipart/formData'
        }}).then((res)=>{
          console.log(res.data)
          viewAllNotifications(loggedInAdmin);

        }).catch((err)=>{console.log(err)})
      }
    });

    // Swal.fire({
    //   title: "Mark All as Read?",
    //   text: `${unreadCount} notifications will be marked as read`,
    //   icon: "question",
    //   showCancelButton: true,
    //   confirmButtonColor: "#7fd3c1",
    //   cancelButtonColor: "#f56565",
    //   confirmButtonText: "Yes, mark all!",
    // }).then((result) => {
    //   if (result.isConfirmed) {
    //     const unread = notifications.filter((n) => n.status === "unread");
    //     const loggedInAdmin = JSON.parse(localStorage.getItem("adminData"));

    //     const promises = unread.map((n) => {
    //       const formData = new FormData();
    //       formData.append("id", n.id);
    //       formData.append("status", "read");
    //       return axios.post(
    //         `${baseUrl}/admin/notifications/updateNotification`,
    //         formData,
    //         {
    //           headers: { "Content-Type": "multipart/form-data" },
    //         },
    //       );
    //     });

    //     Promise.all(promises).then(() => {
    //       viewAllNotifications(loggedInAdmin);
    //       Swal.fire({
    //         icon: "success",
    //         title: "Done!",
    //         timer: 2000,
    //         showConfirmButton: false,
    //       });
    //     });
    //   }
    // });
  };

  const deleteNotification = (id) => {
    Swal.fire({
      title: "Delete Notification?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#f56565",
      cancelButtonColor: "#718096",
      confirmButtonText: "Yes, delete!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${baseUrl}/admin/notifications/deleteNotification/${id}`)
          .then((res) => {
            if (res.data.success === true) {
              setNotifications(notifications.filter((n) => n.id !== id));
              Swal.fire({
                icon: "success",
                title: "Deleted!",
                timer: 1500,
                showConfirmButton: false,
              });
            }
          })
          .catch((err) => console.log(err));
      }
    });
  };

  const clearAllNotifications = () => {
    Swal.fire({
      title: "Clear All Notifications?",
      text: "This cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#f56565",
      cancelButtonColor: "#718096",
      confirmButtonText: "Yes, clear all!",
    }).then((result) => {
      if (result.isConfirmed) {
        const loggedInAdmin = JSON.parse(localStorage.getItem("adminData"));
        const promises = notifications.map((n) =>
          axios.delete(
            `${baseUrl}/admin/notifications/deleteNotification/${n.id}`,
          ),
        );
        Promise.all(promises).then(() => {
          setNotifications([]);
          Swal.fire({
            icon: "success",
            title: "Cleared!",
            timer: 2000,
            showConfirmButton: false,
          });
        });
      }
    });
  };

  useEffect(() => {
    const loggedInAdmin = JSON.parse(localStorage.getItem("adminData"));
    viewAllNotifications(loggedInAdmin);
  }, []);

  return (
    <AdminLayout>
      <div className="ntf-notifications-page">
        <Container fluid className="ntf-container">
          {/* Page Header */}
          <div className="ntf-page-header">
            <div className="ntf-header-content">
              <div className="ntf-title-section">
                <h1 className="ntf-page-title">
                  <FaBell className="ntf-title-icon" />
                  Notifications
                  {unreadCount > 0 && (
                    <Badge bg="danger" className="ntf-unread-badge">
                      {unreadCount} New
                    </Badge>
                  )}
                </h1>
                <p className="ntf-page-subtitle">All system & admin alerts</p>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="ntf-action-section">
            <Button
              className="ntf-action-btn ntf-btn-read"
              onClick={markAllAsRead}
              disabled={unreadCount === 0}
            >
              <FaCheckDouble className="ntf-btn-icon" /> Mark All as Read
            </Button>
            <Button
              className="ntf-action-btn ntf-btn-clear"
              onClick={clearAllNotifications}
              disabled={notifications.length === 0}
            >
              <FaTrashAlt className="ntf-btn-icon" /> Clear All
            </Button>
            <Button
              className="ntf-action-btn ntf-btn-read"
              onClick={() => setShowAddForm(!showAddForm)}
            >
              + Add Notification
            </Button>
          </div>

          {/* Create Form */}
          {showAddForm && (
            <div
              className="ntf-action-section"
              style={{ flexDirection: "column", gap: "10px" }}
            >
              <input
                className="form-control"
                placeholder="Title"
                value={Title}
                onChange={(e) => setTitle(e.target.value)}
              />
              <input
                className="form-control"
                placeholder="Description"
                value={Descrption}
                onChange={(e) => setDescrption(e.target.value)}
              />
              <Button
                className="ntf-action-btn ntf-btn-read"
                onClick={createNotification}
              >
                Save Notification
              </Button>
            </div>
          )}

          {/* Notifications List */}
          <Row className="ntf-notifications-row">
            {pageLoading ? (
              <Spinner />
            ) : (
              <Col lg={12}>
                {notifications.length === 0 ? (
                  <div className="ntf-empty-state">
                    <FaBell className="ntf-empty-icon" />
                    <h3 className="ntf-empty-title">No Notifications</h3>
                    <p className="ntf-empty-text">You're all caught up!</p>
                  </div>
                ) : (
                  notifications.map((notification) => (
                    <div
                      key={notification.id}
                      className={`ntf-notification-card ${notification.status === "unread" ? "ntf-unread" : ""}`}
                      onClick={() =>
                        notification.status === "unread" &&
                        markAsRead(notification.id)
                      }
                    >
                      <div className="ntf-card-content">
                        <div className="ntf-notification-details">
                          <div className="ntf-notification-header">
                            <h4 className="ntf-notification-title">
                              {notification.title}
                              {notification.status === "unread" && (
                                <span className="ntf-new-indicator">NEW</span>
                              )}
                            </h4>
                            <button
                              className="ntf-delete-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                deleteNotification(notification.id);
                              }}
                            >
                              <FaTimes />
                            </button>
                          </div>
                          <p className="ntf-notification-message">
                            {notification.descrption}
                          </p>
                          <span className="ntf-notification-time">
                            <FaBell className="ntf-time-icon" />{" "}
                            {notification.created_at}
                          </span>
                        </div>
                      </div>
                      {notification.status === "unread" && (
                        <div className="ntf-unread-indicator"></div>
                      )}
                    </div>
                  ))
                )}
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </AdminLayout>
  );
};

export default Notifications;
